module.exports = __webpack_public_path__ + "static/media/backup.bdd35762.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/backup.svg
// module id = 1109
// module chunks = 49